/**
 * Добавленное сегодня на «Словах и модулях» (2026-10-28): карточки сегодняшних нажатий «Создать», которые ещё не
 * тренировали, — с сервера (`GET /cards/words/fresh`). Подсветка слов, «+N · сегодня» у модуля и «Тренировать новые»
 * считаются из одного ответа, поэтому не расходятся и не пропадают после обновления страницы. Чистые функции без
 * alias-импортов — их собирают тесты.
 */

interface FreshByModule {
  byModule: Record<string, readonly string[]>;
}

/** Сколько таких карточек в каждом модуле — метка «+N» на полке и в списке модулей. */
export function freshCounts(fresh: FreshByModule | undefined): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [moduleId, ids] of Object.entries(fresh?.byModule ?? {})) if (ids.length > 0) out[moduleId] = ids.length;
  return out;
}

/** Все такие карточки — подсвеченные строки «Слов». */
export function freshStateSet(fresh: FreshByModule | undefined): ReadonlySet<string> {
  return new Set(Object.values(fresh?.byModule ?? {}).flat());
}
